import { LayoutConfirmationFooter } from '@molecules';
import { PageHeader } from '@organisms';
import { useNavigate } from 'react-router-dom';

import { useCreateOrderBump } from '../../hooks/useCreateOrderBump';

type TLayoutCreateOrderBumpProps = {
  children: React.ReactNode;
};

export function LayoutCreateOrderBump({
  children,
}: TLayoutCreateOrderBumpProps) {
  const {
    handleCancel,
    dispatchSubmit,
    titlePage,
    ableToSave,
    textButtonSubmit,
    isLoadingSave,
    textButtonPreview,
  } = useCreateOrderBump();

  const navigate = useNavigate();

  return (
    <LayoutConfirmationFooter
      onCancel={handleCancel}
      onSave={dispatchSubmit}
      isLoadingSave={isLoadingSave.value}
      cancelLabelButton={textButtonPreview}
      ableToSave={ableToSave.value}
      continueLabelButton={textButtonSubmit}
    >
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={titlePage}
        subTitle={'Crie uma nova oferta especial'}
      />
      {children}
    </LayoutConfirmationFooter>
  );
}
